<template>
  <router-link
    :to="playlistLink"
  >
    <h4
      class="playlist__title mb-4 mt-0"
    >
      <PlaylistTitle
        :is-private="playlist.isPrivate"
        :title="playlist.title"
      />
    </h4>

    <playlist-card
      :playlist="playlist"
    />
  </router-link>
</template>

<script lang="ts">
import Vue, { PropType } from 'vue';
import { Model } from '@viddsee/server-api-client';

import User from '@/scripts/libs/login/User';
import PlaylistCard from './PlaylistCard.ts.vue';
import PlaylistTitle from '../Shared/PlaylistTitle.vue';
import { UserInfoCompat } from '@/scripts/libs/login/userResponseProcessor';

export default Vue.extend({
  components: {
    PlaylistCard,
    PlaylistTitle,
  },
  props: {
    playlist: {
      type: Object as PropType<Model.Playlist.VideoCollectionInfo>,
      required: true,
    },
    baseUrl: {
      type: String,
      default: undefined,
    },
  },
  computed: {
    playlistLink(): string {
      const playlistVanityName = this.playlist.slug;

      if (this.baseUrl) {
        return `${this.baseUrl}/${playlistVanityName}`;
      } else {
        const playlistUser = new User(this.playlist.user) as (User & UserInfoCompat); // TODO: Change this once User has been updated to TS;

        return `/u/${playlistUser.profile.vanity}/playlists/${playlistVanityName}`;
      }
    },
  },
});
</script>

<style lang="scss" scoped>
.playlist__title {
  white-space: nowrap;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
